import { useState } from 'react';
import { Input } from 'antd';
import type { InputRef } from 'antd';

export interface IntInputProps {
  value: number | null;
  onChange: (value: number | null) => void;
  min?: number;
  autoFocus?: boolean;
  disabled?: boolean;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  inputRef?: React.Ref<InputRef>;
  /** LinesGrid keyboard navigation (§1 «Tab и Enter переходят по полям») — см. useGridNavigation. */
  navRow?: number;
  navCol?: number;
}

/** Целое число (коробки, штук в коробке, N) — коммит на blur/Enter, не на каждый символ (§1). */
export function IntInput({ value, onChange, min = 1, autoFocus, disabled, onKeyDown, inputRef, navRow, navCol }: IntInputProps) {
  const [draft, setDraft] = useState(value === null ? '' : String(value));
  const [prevValue, setPrevValue] = useState(value);
  if (value !== prevValue) {
    setPrevValue(value);
    setDraft(value === null ? '' : String(value));
  }

  const commit = () => {
    const digits = draft.replace(/\D/g, '');
    const parsed = digits === '' ? null : Math.max(min, parseInt(digits, 10));
    setDraft(parsed === null ? '' : String(parsed));
    if (parsed !== value) onChange(parsed);
  };

  return (
    <Input
      ref={inputRef}
      value={draft}
      inputMode="numeric"
      autoFocus={autoFocus}
      disabled={disabled}
      className={navRow !== undefined ? 'nav-cell' : undefined}
      data-nav-row={navRow}
      data-nav-col={navCol}
      style={{ textAlign: 'right', width: '100%' }}
      onChange={(e) => setDraft(e.target.value.replace(/\D/g, ''))}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') commit();
        onKeyDown?.(e);
      }}
    />
  );
}
